import React from "react";
import { useSelector } from "react-redux";
import GlobalDeleteDialog from "../../../components/mui/Dialogue/GlobalDeleteDialog";
import {
  deleteBrand,
  deleteCategoryTypes,
  getAllBrands,
  getCategoryTypes,
} from "../../../redux/features/assetManagementSlice";

const DeleteType = ({ id, data }) => {
  const { loading } = useSelector((state) => state.assetmanagement);
  const { paginationData, openAnchor } = useSelector(
    (state) => state.globalDataGrid
  );

  return (
    <GlobalDeleteDialog
      title={"Delete Type"}
      deleteNote={"Are you sure? you want to delete this Type..?"}
      api={deleteCategoryTypes(id)}
      upDateCall={getCategoryTypes(data)}
      loading={loading}
    />
  );
};

export default DeleteType;
